// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__x8DBh","label":"styles_label__3ebAm"};